function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
export function stepFinder(stepId) {
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'field';
  return function (step) {
    return step[field] === stepId;
  };
}
function conditionValidator(conditionValue, stepValue) {
  if (_typeof(conditionValue) === 'object') {
    if (Object.hasOwnProperty.call(conditionValue, 'range')) {
      return stepValue >= conditionValue.range.min && stepValue <= conditionValue.range.max;
    }
    return false;
  } else if (conditionValue instanceof Array) {
    return stepValue instanceof Array && conditionValue.every(function (partialValue) {
      return stepValue.includes(partialValue);
    });
  } else if (typeof conditionValue === 'undefined') {
    return true;
  }
  return conditionValue === stepValue;
}
export function getStepRelatives(stepId, steps, currentValue, stepValues) {
  var currentStep = steps.find(stepFinder(stepId));
  var previousStep = steps.find(function (_ref) {
    var conditions = _ref.conditions,
      field = _ref.field,
      order = _ref.order;
    return order < currentStep.order && conditions.some(function (_ref2) {
      var value = _ref2.value;
      return conditionValidator(value, stepValues[field]);
    });
  });
  if (!previousStep) previousStep = steps.find(stepFinder(currentStep.order - 1, 'order')) || currentStep;
  var nextStep = currentStep.conditions.filter(function (condition) {
    return Object.hasOwnProperty.call(condition, 'value') && Object.hasOwnProperty.call(condition, 'step') || !Object.hasOwnProperty.call(condition, 'value') && Object.hasOwnProperty.call(condition, 'step');
  }).find(function (_ref3) {
    var value = _ref3.value;
    return conditionValidator(value, currentValue);
  });
  if (nextStep) nextStep = steps.find(stepFinder(nextStep.step));
  if (!nextStep) nextStep = steps.find(stepFinder(currentStep.order + 1, 'order'));
  var isLastStep = !nextStep;
  var isFirstStep = currentStep === previousStep;
  return {
    currentStep: currentStep,
    previousStep: previousStep,
    nextStep: nextStep,
    isFirstStep: isFirstStep,
    isLastStep: isLastStep
  };
}
export var getInitialStep = function getInitialStep(app, initialFields) {
  var initialFieldsNames = Object.keys(initialFields);
  var _app$steps$filter = app.steps.filter(function (step) {
      return !initialFieldsNames.includes(step.field);
    }),
    _app$steps$filter2 = _slicedToArray(_app$steps$filter, 1),
    firstStep = _app$steps$filter2[0];
  return firstStep;
};
export var getAppFields = function getAppFields(app) {
  var fields = app.steps.map(function (step) {
    return app.fields.find(function (_ref4) {
      var field = _ref4.field;
      return field === step.field;
    });
  });
  return fields;
};